import { type EmbeddedVideosFiltersEnum } from "features/Library/EmbeddedVideos/types/models";
import React, { type FC } from "react";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { type FilterFormPropsBase } from "../types/props";
import { getEmbeddedVideosFilters } from "./embeddedVideosFiltersUtils";

export interface EmbeddedVideosFilterFormForPacksProps extends FilterFormPropsBase<EmbeddedVideosFiltersEnum> {}

const EmbeddedVideosFilterFormForPacks: FC<EmbeddedVideosFilterFormForPacksProps> = ({
  filterOptions,
  filter,
  updateFilter,
  onValidationChange,
}) => (
  <FilterFormBuilder
    filterOptions={filterOptions}
    filter={filter}
    updateFilter={updateFilter}
    items={getEmbeddedVideosFilters(false)}
    onValidationChange={onValidationChange}
  />
);

export default EmbeddedVideosFilterFormForPacks;
